
<template>
<div class="order-manage-create-page">
<!-- <BlockPanel class="adress-info-component" v-bind="$props"> -->
    <div class="address-choose">
        <a-button v-if="!disabled" type="link" @click="handleSelect">
        <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
    </div>
    <a-row >
         <a-col :md="8" :sm="24">
            <a-form-model-item
                label="站点名称"
                :colon="false"
            >
                <a-input v-model="startStation.stationName" placeholder="请输入"></a-input>
            </a-form-model-item>
        </a-col>
        <a-col :md="8">
            <FormItemName
                v-model.trim="startStation.contactName"
                :prop-prefix="propPrefix"
                :disabled="disabled"
             />
        </a-col>
        <a-col :md="8" :sm="24">
            <FormItemPhone
                v-model="startStation.contactPhone"
                :prop-prefix="propPrefix"
                :disabled="disabled"
             />
        </a-col>
        <a-col :md="8" :sm="24">
            <a-form-model-item
                label="要求取货时间"
                :colon="false"
                :prop="`${propPrefix}.expectTime`"
                :rules="timeRules"
            >
                <a-date-picker
                    v-model="startStation.expectTime"
                    :disabled-date="disabledDate"
                    :disabled-time="disabledDateTime"
                    :show-time="{defaultValue: defaultTime}"
                    placeholder="请选择"
                    @change="handleChange"
                    @focus="handleFocus" />
            </a-form-model-item>
        </a-col>
        <a-col :md="16" :sm="24">
            <!-- <FormItemAddress
            :address="startStation"
            :prop-prefix="propPrefix"
            :disabled="disabled"
            @change="handleAdressChange" /> -->
            <a-form-model-item
                label="联系人地址"
                :colon="false"
                :label-col="{span: 3}"
                :wrapper-col="{span: 21}"
                :rules="addressRules"
                :prop="`${propPrefix}.address`"
            >
                <address-detil 
                :default-address="defaultAddress"
                :default-suffix="defaultSuffix"
                @updateData="handleAdressChange"
                @removeData="removeData"></address-detil>
            </a-form-model-item>
        </a-col>
    </a-row>
    <slot></slot>
<!-- </BlockPanel> -->
<SelectAddressDialog ref="SelectAddressDialog" :station-type="StationTypes.SHIPPING" :is-standard='true' @onSelectAddress="handleAdressFromSelectorChange"/>
</div>

</template>
<script>
import moment from 'moment';
// import BlockPanel from '@/components/panel/BlockPanel.vue'
import FormValidator from '@/constants/formValidator'
import { mapState } from 'vuex'
import {TIME_UNIT,TIME_UNIT_MAP,range} from '@/constants/ruleConfig'
import SelectAddressDialog from '../../components/SelectAddressDialog.vue'
import {
    FormItemName,
    FormItemPhone,
    // FormItemAddress
} from '../../components/FormItem'
import { StationTypes } from '../../constant';
import AddressDetil from './AddressDetil.vue'

const cn = require('ant-design-vue/es/locale-provider/zh_CN')

export default {
    components: {
        // BlockPanel,
        SelectAddressDialog,
        FormItemName,
        FormItemPhone,
        // FormItemAddress
        AddressDetil,
    },
    model: {
        prop: 'startStation',
        event: 'change'
    },
    props: {
        startStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        propPrefix: {
            type: String,
            default: 'startStation'
        },
        isPretend: {
            type: Boolean,
            default: false
        },
        pretendStation: {
            type: Array,
            default: () => [],
        }
    },
    data () {
        return {
            cn,
            defaultTime: moment('00:00:00', 'HH:mm:ss'),
            FormValidator,
            StationTypes,
            defaultAddress: '',
            defaultSuffix: '',
            addressRules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ],
            timeRules: [
                { required: true, message: '请选择需要取货时间', trigger: 'change' },
            ],
            current:null,
        }
    },
    computed:{
      ...mapState('orderRules', ['orderRules']),
    },
    watch:{
        startStation: {
            handler(val){
                if(val.expectTimeLeft && val.expectTimeLeft.length>0){
                    this.defaultTime=moment(val.expectTimeLeft[0]||'00:00:00','HH:mm:ss')
                }else{
                    this.defaultTime=moment('00:00:00', 'HH:mm:ss')
                }
                if(val.address){
                    this.defaultSuffix = `${val.provinceName}${val.cityName}${val.countyName}${val.address}` 
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
      handleFocus(){
        this.current = new Date();
      },
      handleChange(value){
          if(!value){
            this.$set(this.startStation,'expectTime',null)
            return
          }
          const {flag,makeupStartTimeNum,makeupStartTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 是否跟结束日期相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          if(isSameStart){
            if(value < startTime){
              this.$set(this.startStation,'expectTime',moment(startTime))
            }else{
              this.$set(this.startStation,'expectTime',value)
            }
          }else{
            this.$set(this.startStation,'expectTime',value)
          }
      },
        disabledDate(current){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          let startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current).subtract(1, "days");
          let endTime =moment(this.current).add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          if(makeupStartTimeUnit){
            startTime = moment(startTime).subtract(1 , 'days')
          }
          if(createStartTimeUnit === TIME_UNIT.HOURS){
            endTime = moment(endTime)
          }
          return current && moment(current).startOf('days') < startTime|| moment(current).startOf('days') > endTime
        },
        disabledDateTime(){
          return {
			      disabledHours: () => this.disabledHours(this.orderRules.ORDER_CREATE_TIME_CHECK),
			      disabledMinutes: () => this.disabledMinutes(this.orderRules.ORDER_CREATE_TIME_CHECK),
		      };
        },
        disabledHours(data){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.startStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          // 获取当前时间小时
          const currentHours = moment(this.current).hour();
          // 结束时间小时数计算
          const endHours = createStartTimeUnit === TIME_UNIT.HOURS? currentHours + createStartTimeNum:currentHours;
          // 开始时间小时数计算
          const startHours = makeupStartTimeUnit === TIME_UNIT.HOURS? currentHours - makeupStartTimeNum:currentHours;
          // hours数组
          const hoursList = range(0,24);
          // 结束禁用小时列表
          const endDisabledList =  hoursList.splice(hoursList.indexOf(endHours)+1,24);
          // 开始禁用小时列表
          const startDisabledList =  hoursList.splice(0,hoursList.indexOf(startHours));
          if(isSameEnd&&isSameStart){
            return [...startDisabledList,...endDisabledList]
          }
          if(isSameEnd){
            return endDisabledList
          }if(isSameStart){
            return startDisabledList
          }
          return []
        },
        disabledMinutes(data){
          const {flag,createStartTimeNum,makeupStartTimeNum,createStartTimeUnit,makeupStartTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.startStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.startStation.expectTime||this.current).isSame(startTime, 'day');
          // 开始时间是多少小时
          const startHours= flag ? moment(this.current).subtract(Number(makeupStartTimeNum),TIME_UNIT_MAP[makeupStartTimeUnit]).hour():moment(this.current).hour();
          // 获取当前时间小时
          const currentHours = this.startStation.expectTime? moment(this.startStation.expectTime).hour():startHours;
          // 结束时间是多少小时
          const endHours=  moment().add(+Number(createStartTimeNum),TIME_UNIT_MAP[createStartTimeUnit]).hour()
          if(isSameStart&&currentHours === startHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(0,minuteList.indexOf(endMinute))
            return disabled
          }if(isSameEnd&&currentHours === endHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(minuteList.indexOf(endMinute),60)
            return disabled
          }
          return []
        },
        handleSelect() {
            this.$refs.SelectAddressDialog.show({})
        },
        handleAdressFromSelectorChange({
            contacts, telPhone,stationName,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode, sourceStationId
        }) {
            const arr = []
            // 多装多卸不予许选择相同起始站点
            if(this.isPretend){
                this.pretendStation.forEach((e) => {
                    if (e.provinceCode === provinceCode && e.cityCode === cityCode && e.countyCode === countyCode && e.address === address) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                this.update({
                    contactPhone: telPhone,
                    contactName: contacts,
                    province: provinceName,
                    city: cityName,
                    county: countyName,
                    provinceName,
                    cityName,
                    countyName,
                    address,
                    provinceCode,
                    cityCode,
                    countyCode,
                    stationId: sourceStationId,
                    stationName
                })
            } else {
                this.$message.warning('发货地信息不能重复！')
            }
        },
        handleAdressChange(address) {
            const arr = []
            // 多装多卸不予许选择相同起始站点
            if(this.isPretend){
                this.pretendStation.forEach((e) => {
                    if (e.provinceCode === address.provinceCode && e.cityCode === address.cityCode && e.countyCode === address.countyCode && e.address === address.address) {
                        arr.push(e)
                    }
                })
            }
            if(arr.length <= 0){
                this.update(address)
            } else {
                this.defaultAddress = ' '
                this.defaultSuffix = ' '
                this.$message.warning('发货地信息不能重复！')
            }
        },
        update(infos) {
            const {address, province, city, county} = infos
            this.$emit('changeDetil',{
                ...infos,
                stationFullAddress: `${province || ''}${city || ''}${county || ''}${address || ''}`,
                provinceName: province,
                cityName: city,
                countyName: county,
                address
            })
            this.$emit('change', {
                ...this.startStation,
                ...infos,
                provinceName: province,
                cityName: city,
                countyName: county,
                stationFullAddress: `${province || ''}${city || ''}${county || ''}${address || ''}`,
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm} = this.startStation
            this.$emit('changeDetil', '')
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType: 0,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
            })
        },
    },
}
</script>

<style lang="less" scoped>
.address-choose {
    padding-left: 32px;
    margin-bottom: 14px;
    .ant-btn {
        padding: 0;
    }
}
// .order-manage-create-page {
//     border: 0;
// }
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    .subtitle {
        flex: 1;
        font-weight: bold;
        font-size: 16px;
    }
}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
/deep/ .ant-card-body{
    padding-top: 16px !important;
}
</style>